import { Building, Clock, DollarSign, MapPin, Phone, Info } from 'lucide-react';
import * as React from 'react';
import { Card } from '#app/components/ui/card';
import { Separator } from '#app/components/ui/separator';

// Define props type
interface StationInfoProps {
  station: {
    address: string | null;
    hours: string | null;
    costDescription: string | null;
    parkingLevel: string | null;
    formattedPhoneNumber: string | null;
  } | null;
}

export function StationInfo({ station }: StationInfoProps) {
  if (!station) {
    return null;
  }

  const infoItems = [
    {
      icon: MapPin,
      label: "Endereço",
      value: station.address,
      capitalize: true,
    },
    { icon: Clock, label: "Horário", value: station.hours },
    { icon: DollarSign, label: "Preço", value: station.costDescription },
    {
      icon: Building,
      label: "Estacionamento",
      value: station.parkingLevel,
      capitalize: true,
    },
    { icon: Phone, label: "Telefone", value: station.formattedPhoneNumber },
  ];

  const visibleItems = infoItems.filter((item) => item.value);

  if (visibleItems.length === 0) {
    return null; // Don't render the component if there's no info to show
  }

  return (
    <Card className='overflow-hidden bg-white shadow-sm backdrop-blur-sm'>
      <div className='p-5'>
        <div className='mb-4 flex items-center gap-2'>
          <Info className='h-5 w-5 text-primary' />
          <h3 className='text-lg font-semibold'>Informações</h3>
        </div>
        <div className='space-y-4'>
          {visibleItems.map((item, index) => (
            <React.Fragment key={index}>
              <div className='group flex items-start gap-3'>
                <div className='mt-0.5'>
                  <item.icon className='h-4 w-4 text-muted-foreground/70 transition-colors group-hover:text-primary' />
                </div>
                <div className='flex-1 space-y-1'>
                  <p className='font-semibold text-sm text-foreground/90'>
                    {item.label}
                  </p>
                  <p
                    className={`text-sm text-muted-foreground ${
                      item.capitalize ? 'capitalize' : ''
                    }`}
                  >
                    {item.value}
                  </p>
                </div>
              </div>
              {index < visibleItems.length - 1 && (
                <Separator className='bg-border/40' />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </Card>
  );
}
